import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { QuestionnairesListContainerState } from './questionnaireslist';

const initialState: QuestionnairesListContainerState = {
  default: 'default',
};

export const questionnairesListSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setDefault: (state, action: PayloadAction<string>) => {
      state.default = action.payload;
    },
  },
});

export const {
  setDefault,
} = questionnairesListSlice.actions;

export default questionnairesListSlice.reducer;
